<template>
    <div class="not-found-main">
        <div class="content-area">
            <base-header
                :menu-listing="menuListing"
                @sidemenu="$emit('responsiveSideBar')"
            ></base-header>
            <div class="right-panel">
                <div class="not-found">
                    <div class="not-found-panel">
                        <div class="file-download">
                            <i class="icon-export"></i>
                            <h2>{{ message }}</h2>

                            <router-link
                                :to="{ name: 'view-alerts' }"
                                class="btn btn-primary back-to-login-btn text-decoration-none"
                            >
                                <span>BACK TO HOME</span>
                            </router-link>
                        </div>
                    </div>
                </div>

                <router-view />
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash'
import request from '@/utils/request'
export default {
    components: {},
    data() {
        return {
            menuListing: [],
            message: 'File has been downloaded',
            buttonText: 'Back To Home',
        }
    },
    mounted() {
        this.downloadFile()
    },
    methods: {
        forceFileDownload(response) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute(
                'download',
                _.capitalize(this.$route.params.type) + '.xlsx'
            ) //or any other extension
            document.body.appendChild(link)
            link.click()
        },

        async downloadFile() {
            var imageUrl =
                this.$route.params.folder + '/' + this.$route.params.fileName

            try {
                let response = await request({
                    url: `/files/${imageUrl}`,
                    responseType: 'arraybuffer',
                })
                this.forceFileDownload(response)
            } catch (err) {
                // console.log('Error occured: ', err)
            }
        },
    },
}
</script>
